<div class="kpis-container" *ngIf="kpisByCategory">
  <div class="kpis-view-toggle">
    <core-segmentedbuttons>
      <core-segmentedbuttons-item
        label="Grid view"
        [attr.selected]="selectedView === 'cards' ? true : null"
        slot="segment"
        (click)="toggleView('cards')"
      ></core-segmentedbuttons-item>
      <core-segmentedbuttons-item
        label="List view"
        [attr.selected]="selectedView === 'table' ? true : null"
        slot="segment"
        (click)="toggleView('table')"
      ></core-segmentedbuttons-item>
    </core-segmentedbuttons>
  </div>
  <span class="kpis-title">
    KPIs
    <span class="kpis-title-stages">
      {{ titleStages }}
    </span>
  </span>
  <div @enterAnimation *ngIf="kpisByCategoryArray.length">
    <kpis-table-view
      [ngClass]="{ 'kpis-hidden': selectedView !== 'table' }"
      [kpisByCategory]="kpisByCategoryArray"
      [keyMilestones]="keyMilestones"
    ></kpis-table-view>
    <kpis-card-view
      [ngClass]="{ 'kpis-hidden': selectedView !== 'cards' }"
      [kpisByCategory]="kpisByCategoryArray"
      [keyMilestones]="keyMilestones"
    >
    </kpis-card-view>
  </div>
  <kpis-zero-state @enterAnimation *ngIf="!kpisByCategoryArray.length"></kpis-zero-state>
</div>
